export enum DateComparisonType {
    OLDER = 'older',
    NEWER = 'newer',
}
